// Connecting an External Assistant (M3-18): the Cell's authorization server sends a person with no web session here
// as `/?oauth=<its page>`, since the SameSite=Strict session cookie never arrives on a navigation from the
// assistant's site. Once signed in, LAMP goes back to that page from its own origin, cookie and all. Only the
// authorization server's own pages are gone back to, so the link cannot send anyone elsewhere.

const THIS_ORIGIN = "https://lamp.invalid";

/** The authorization server page `?oauth=` names, as a path on this origin, or undefined for anything else. */
export function oauthReturn(search: string): string | undefined {
  const value = new URLSearchParams(search).get("oauth");
  if (value === null || !value.startsWith("/oauth/") || value.includes("\\")) return undefined;
  const url = URL.parse(value, THIS_ORIGIN);
  if (url?.origin !== THIS_ORIGIN || !url.pathname.startsWith("/oauth/")) return undefined;
  return `${url.pathname}${url.search}`;
}
